import { render, staticRenderFns } from "./ModalInabilitarFornecedor.vue?vue&type=template&id=233abbeb&"
import script from "./ModalInabilitarFornecedor.vue?vue&type=script&lang=js&"
export * from "./ModalInabilitarFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports